// Kleine Datumshilfen für das Mietkonto (UTC, ohne Zeitzonen-Sprünge).

const zerlege = (iso: string): [number, number, number] => [Number(iso.slice(0, 4)), Number(iso.slice(5, 7)), Number(iso.slice(8, 10)) || 1];

export function monatsAnfang(iso: string): string {
  return `${iso.slice(0, 7)}-01`;
}

export function tageImMonat(monat: string): number {
  const [j, m] = zerlege(monat);
  return new Date(Date.UTC(j, m, 0)).getUTCDate();
}

export function monatsEnde(monat: string): string {
  return `${monat.slice(0, 7)}-${String(tageImMonat(monat)).padStart(2, '0')}`;
}

export function plusMonate(monat: string, n: number): string {
  const [j, m] = zerlege(monat);
  return new Date(Date.UTC(j, m - 1 + n, 1)).toISOString().slice(0, 10);
}

/** Alle Monatsanfänge von `von` bis einschließlich `bis`. */
export function monateZwischen(von: string, bis: string): string[] {
  const aus: string[] = [];
  let m = monatsAnfang(von);
  const ende = monatsAnfang(bis);
  while (m <= ende && aus.length < 1200) { aus.push(m); m = plusMonate(m, 1); }
  return aus;
}

/** Tag im Monat, auf die Monatslänge begrenzt (Fälligkeit „31.“ im Februar → 28./29.). */
export function tagImMonat(monat: string, tag: number): string {
  const t = Math.min(Math.max(1, Math.round(tag)), tageImMonat(monat));
  return `${monat.slice(0, 7)}-${String(t).padStart(2, '0')}`;
}

export function tageZwischen(von: string, bis: string): number {
  const [j1, m1, t1] = zerlege(von);
  const [j2, m2, t2] = zerlege(bis);
  return Math.round((Date.UTC(j2, m2 - 1, t2) - Date.UTC(j1, m1 - 1, t1)) / 86_400_000);
}

const MON = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];

/** „Okt 26“ */
export function monatsLabel(monat: string): string {
  return `${MON[Number(monat.slice(5, 7)) - 1] ?? ''} ${monat.slice(2, 4)}`;
}

/** Auf Cent runden; liefert nie −0. */
export const runde = (n: number): number => Math.round(n * 100) / 100 || 0;
